export enum IntegrationTypeAuthType {
  Oauth = 'OAUTH',
  Token = 'TOKEN',
  NONE = 'NONE',
}

export enum CustomIntegrationType {
  Tap = 'TAP',
  FileUpload = 'FILE_UPLOAD',
}
export enum IntegrationTypePropertyType {
  Boolean = 'boolean',
  String = 'string',
  Integer = 'integer',
  Array = 'array',
  Object = 'object',
}

export enum IntegrationTypePropertyFormat {
  DateTime = 'date-time',
  Password = 'password',
}

export enum IntegrationPropertyValidator {
  Email = 'email',
}

export interface $ref {
  $ref: string;
}

export interface IntegrationTypeSettingOauth {
  authType: IntegrationTypeAuthType.Oauth;
  oauth: {
    client_params: string[];
    url_params: string[];
  };
}

export interface IntegrationTypeSettings {
  authType: IntegrationTypeAuthType;
}

export type IntegrationTypePropertySettings = IntegrationTypeSettingOauth | IntegrationTypeSettings;

export interface IntegrationTypePropertyBase {
  title?: string;
  description?: string;
  settings?: IntegrationTypePropertySettings;

  format?: IntegrationTypePropertyFormat;
  default?: unknown;
  items?: {
    $ref: string;
    anyOf: $ref[];
  };
  order?: number;
  minimum?: number;
  maximum?: number;
  min?: number;
  max?: number;
  const?: string;
  multiline?: boolean;
  metadata?: {
    from_resource?: string;
    type?: 'file-upload';
    multiple?: boolean;
    is_settings?: boolean;
    validation?: IntegrationPropertyValidator[];
    wording?: Record<string, string>;
    show_dropdown_value?: boolean;
    order?: number;
  };
}

export interface IntegrationTypePropertyBaseWithType extends IntegrationTypePropertyBase {
  type?: IntegrationTypePropertyType;
}

export interface IntegrationTypePropertyBaseWithAllOf extends IntegrationTypePropertyBase {
  allOf?: $ref[];
}

export interface IntegrationTypePropertyBaseWithAnyOf extends IntegrationTypePropertyBase {
  anyOf?: $ref[];
}

/**
    OneOf is a special case of AnyOf, but it does not have definitions for each type.
    Instead, it has a list of groups of properties that can be used to generate a form.
    One of the properties - common between each item of the list - will be used to determine what properties should be shown to user and included.
*/
export interface IntegrationTypePropertyBaseWithOneOf extends IntegrationTypePropertyBase {
  type: IntegrationTypePropertyType.Object;
  oneOf: NestedAnyOfIntegrationTypeDefinition[];
}

/*
 * This is a type that decribes a definition that is nested in anyOf.
 * It lacks a type property, but implicitly it has type = 'object'.
 */
export interface NestedAnyOfIntegrationTypeDefinition {
  title: string;
  description?: string;
  required?: string[];
  properties?: Record<string, IntegrationTypeProperty>;
}

/**
 * Nested Form - type:object and properties - nested list of properties.
 * It should not have any definitions
 */

export interface IntegrationTypePropertyBaseWithNested extends IntegrationTypePropertyBase {
  type: IntegrationTypePropertyType.Object;
  properties?: Record<string, IntegrationTypeProperty>;
  required?: string[];
}

export type IntegrationTypeProperty =
  | IntegrationTypePropertyBaseWithType
  | IntegrationTypePropertyBaseWithAllOf
  | IntegrationTypePropertyBaseWithAnyOf
  | IntegrationTypePropertyBaseWithOneOf;

export interface IntegrationTypeDefinition {
  title?: string;
  type: IntegrationTypePropertyType;
  description?: string;
  settings?: IntegrationTypePropertySettings;

  required?: string[];
  properties?: Record<string, IntegrationTypeProperty>;
  enum?: string[];
}

export interface IntegrationTypeJSONSchema {
  $schema: string;
  type: IntegrationTypePropertyType;
  title: string;
  required?: string[];
  properties?: Record<string, IntegrationTypeProperty>;
  definitions?: Record<string, IntegrationTypeDefinition>;
  settings?: IntegrationTypePropertySettings;
}

export interface IntegrationTypeSourceJSONSchema extends IntegrationTypeJSONSchema, Record<string, unknown> {
  imageURL?: string;
  description?: string;
  settings: {
    authType: IntegrationTypeAuthType;
    integrationType?: CustomIntegrationType;
    hasFixedColumns: boolean;
    hasIncremental?: boolean;
  };
}

export interface IntegrationTypeSecretJSONSchema extends IntegrationTypeJSONSchema, Record<string, unknown> {
  oauth?: {
    client_params: string[];
    url_params: string[];
  };
}

export interface IntegrationTypeSecretJSONSchemaV2 extends Record<string, unknown> {
  $schema: string;
  title: string;
  type: IntegrationTypePropertyType;
  required?: string[];
  properties: {
    auth: IntegrationTypeProperty;
  } & Record<string, IntegrationTypeProperty>;
  definitions?: Record<string, IntegrationTypeDefinition>;
  settings?: IntegrationTypePropertySettings;
}
